import { AbstractWSService } from "@/services/socket/ws.service";
import { type WSConnection } from "@/plugins/ws.connection";
import { TripMonitorHandler } from "@/services/socket/handler/trip.monitor.handle.service";
import { TripViewHandler } from "@/services/socket/handler/trip.view.handler.service";

export class TripService extends AbstractWSService {
  constructor(connection: WSConnection) {
    const tripMonitorHandler = new TripMonitorHandler();
    const tripViewHandler = new TripViewHandler();

    super(connection, {
      eventHandler: (data: any) => {
        tripMonitorHandler.handleWSData(data);
        tripViewHandler.handleWSData(data);
      },
    });
  }
}
